module.exports = __webpack_public_path__ + "img/esquemaF.98258a0c.svg";